module.exports = __webpack_public_path__ + "img/video-player.e8306b43.svg";